var $ = require('jquery')

function Timesheet (raw) {
    Timesheet.prototype.init.call(this, raw)
}

$.extend(Timesheet.prototype, {
    timesheet_id: null,
    employee_id: null,
    working_date: null,
    start_working_time: null,
    end_working_time: null,
    real_lunch_time: null,
    working_out: null,
    furikyu_taisho: null,
    note: null,
    init: function (raw) {
        var self = this

        self.timesheet_id = raw && raw.timesheet_id ? raw.timesheet_id : null
        self.employee_id = raw && raw.employee_id ? raw.employee_id : null
        self.working_date = raw && raw.working_date ? raw.working_date : null
        self.start_working_time = raw && raw.start_working_time ? raw.start_working_time : null
        self.end_working_time = raw && raw.end_working_time ? raw.end_working_time : null
        self.real_lunch_time = raw && raw.real_lunch_time ? raw.real_lunch_time : null
        self.working_out = raw && raw.working_out ? raw.working_out : null
        self.furikyu_taisho = raw && raw.furikyu_taisho ? raw.furikyu_taisho : null
        self.note = raw && raw.note ? raw.note : null
    }

})

module.exports = Timesheet

function TimesheetList (raw) {
    TimesheetList.prototype.init.call(this, raw)
}

$.extend(TimesheetList.prototype, {
    items: null,

    init: function (raw) {
        var self = this

        var items = []

        if (raw) {
            for (var i = 0; i < Object.keys(raw).length; i++) {
                items.push(raw[Object.keys(raw)[i]])
            }
        }

        self.items = items
    },

    update: function (raw) {
        var self = this

        var items = []

        for (var i = 0; i < Object.keys(raw).length; i++) {
            items.push(raw[Object.keys(raw)[i]])
        }

        self.items = items
    }
})

module.exports = TimesheetList



// WEBPACK FOOTER //
// ./client/models/timesheetmodel.js